__turbopack_context__.v({
  "basic": "a2Cm-W_basic",
  "cards-wrapper": "a2Cm-W_cards-wrapper",
  "context": "a2Cm-W_context",
  "flex": "a2Cm-W_flex",
  "header": "a2Cm-W_header",
  "offering-content": "a2Cm-W_offering-content",
  "pro": "a2Cm-W_pro",
  "pro-cards": "a2Cm-W_pro-cards",
  "scrollable-pro-cards": "a2Cm-W_scrollable-pro-cards",
  "toggle": "a2Cm-W_toggle",
});
